import { render, staticRenderFns } from "./QuestionCategories.vue?vue&type=template&id=103522ba&scoped=true"
import script from "./QuestionCategories.vue?vue&type=script&lang=ts"
export * from "./QuestionCategories.vue?vue&type=script&lang=ts"
import style0 from "./QuestionCategories.vue?vue&type=style&index=0&id=103522ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103522ba",
  null
  
)

export default component.exports